import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-side-menu-group-content',
  standalone: true,
  imports: [],
  templateUrl: './side-menu-group-content.component.html',
  styleUrl: './side-menu-group-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class SideMenuGroupContentComponent {}
